module Shared.Home.UpdateTelephoneNumber
open Illy.SafeStack

type DTO = 
    {
        TelephoneNumber: string option
        Password: string option
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.ROP
    open Illy.SafeStack.CompositionalValidation
    open Illy.SafeStack.SharedValidations
    open Shared.Validations.Password

    let [<Literal>] TELEPHONE_REGEX = "^[0-9]+$"

    type TelephoneNumberValidations = 
        | StringValidations of StringValidations
        | MustContainOnlyDigits 
        | CannotBeTheSameAsTheOldNumber

    module TelephoneNumberValidations = 
        let toString = 
            function 
            | StringValidations v -> v.toString()
            | MustContainOnlyDigits -> "Enter a valid phone number."
            | CannotBeTheSameAsTheOldNumber -> "New number is the same as the old phone number."

    type UpdateNumberValidations = 
        | TelephoneNumberValidations of TelephoneNumberValidations
        | PasswordValidations of PasswordValidations

    module UpdateNumberValidations = 
        let toString = 
            function 
            | TelephoneNumberValidations v -> TelephoneNumberValidations.toString v
            | PasswordValidations v -> PasswordValidations.toString v
    
    let validateTelephoneNumber oldTelephoneNumber number = 
        validate {
            return! (validateString 50 true >-> TelephoneNumberValidations.StringValidations) number
            return! !!(error TelephoneNumberValidations.MustContainOnlyDigits)
                >>= passIfNone number 
                >>= conditional pass (fun (_, nStr) -> System.Text.RegularExpressions.Regex.IsMatch(nStr, TELEPHONE_REGEX))
                |> firstResult
            return! !!(error TelephoneNumberValidations.CannotBeTheSameAsTheOldNumber)
                >>= passIfNone number 
                >>= conditional pass (fun (_, nStr) -> Some nStr <> oldTelephoneNumber)
                |> firstResult
        }
    
    let validateDTO oldTelephoneNumber (dto: DTO) = 
        validate {
            return! (validateTelephoneNumber oldTelephoneNumber >-> UpdateNumberValidations.TelephoneNumberValidations) dto.TelephoneNumber
            return! (validatePassword >-> UpdateNumberValidations.PasswordValidations) dto.Password
        }

type FailureReason =
    | FailedValidations of Validation.ValidationResult<Validations.UpdateNumberValidations, Validation.NoWarning>
